import { GET_NAVIGATION } from '@plone/volto/constants/ActionTypes';

/**
 * Get navigation.
 * @function getNavigationWithQs
 * @param {string} url Content url.
 * @param {number} depth Depth of the navigation tree.
 * @param {string} qs Extra query string (ex: '&l=1')
 * @returns {Object} Get navigation action.
 */
export function getNavigationWithQs(url, depth, qs = '') {
  const depthQs = depth ? `expand.navigation.depth=${depth}` : '';

  const query = [depthQs, qs.replace(/^&/, '')].filter(Boolean).join('&');

  return {
    type: GET_NAVIGATION,
    request: {
      op: 'get',
      path: `${url}/@navigation${query ? `?${query}` : ''}`,
    },
  };
}
